import { auditLogPermissions } from '@infuse/api/audit-log';
import { organisationUserPermissions } from '@infuse/api/iam/organisation';
import { tenantUserPermissions } from '@infuse/api/iam/tenant';
import { userPermissions } from '@infuse/api/iam/user';
import { UserAuditLogTab, UserDetailSlideIn, UserOverviewTab, UsersPage } from '@infuse/iam/user/pages';

import { InfusePageView } from '@infuse/ui/layouts';
import { AppRouter } from '@infuse/ui/router';
import { Plugin } from 'vue';

export const UserFeaturePlugin: Plugin = {
  install() {
    AppRouter.addRoute('main', {
      path: '/user',
      component: InfusePageView,
      meta: {
        name: 'nav.users',
        icon: 'user',
        group: 'nav.nav-group.iam',
        permissionIds: [userPermissions.SEARCH, organisationUserPermissions.SEARCH, tenantUserPermissions.SEARCH]
      },
      children: [
        {
          path: '',
          name: 'user',
          component: UsersPage
        },

        {
          path: ':id',
          components: {
            default: UsersPage,
            slideIn: UserDetailSlideIn
          },
          children: [
            {
              path: '',
              redirect: {
                name: 'user.details'
              }
            },
            {
              path: 'overview',
              name: 'user.details',
              component: UserOverviewTab,
              meta: {
                type: 'tab',
                label: 'iam.users.tabs.overview',
                permissionIds: [userPermissions.GET, organisationUserPermissions.GET, tenantUserPermissions.GET],
                disablePermissionRouteGuard: true
              }
            },
            {
              path: 'auditlog',
              name: 'user.auditlog',
              component: UserAuditLogTab,
              meta: {
                type: 'tab',
                label: 'iam.users.tabs.auditlog',
                permissionIds: [auditLogPermissions.SEARCH],
                disablePermissionRouteGuard: true
              }
            }
          ]
        }
      ]
    });
  }
};
